import {
  REQUEST_LANGUAGES,
  RECEIVE_LANGUAGES,
  FETCH_ANALYTICS_ORDERS,
  FETCH_ANALYTICS_ORDERS_SUCCESS,
  FETCH_ANALYTICS_ORDERS_FAILURE,
  FETCH_ANALYTICS_SUMMARY,
  FETCH_ANALYTICS_SUMMARY_SUCCESS,
  FETCH_ANALYTICS_SUMMARY_FAILURE,
  FETCH_ANALYTICS_PRODUCTS,
  FETCH_ANALYTICS_PRODUCTS_SUCCESS,
  FETCH_ANALYTICS_PRODUCTS_FAILURE,
  RESET_REFERAL_ERRORS,
} from '../constants/ActionTypes';

export default function referal(
  state = {
    filter: 'ALL',
    errors: [],
    languages: [],
    analyticsOrders: {
      rows: [],
      totalCount: 0,
      isFetching: false,
    },
    analyticsSummary: {
      data: {},
      isFetching: false,
    },
    analyticsProducts: {
      items: [],
      isFetching: false,
    },
    isFetching: false,
  },
  action
) {
  switch (action.type) {
    case REQUEST_LANGUAGES:
      return {
        ...state,
        isFetching: true,
      };

    case RECEIVE_LANGUAGES:
      return {
        ...state,
        isFetching: false,
        languages: action.data,
      };

    case FETCH_ANALYTICS_ORDERS:
      return {
        ...state,
        errors: state.errors.filter(
          (error) => error !== 'fetchingAnalyticsOrdersError'
        ),
        analyticsOrders: {
          ...state.analyticsOrders,
          isFetching: true,
        },
      };

    case FETCH_ANALYTICS_ORDERS_SUCCESS:
      return {
        ...state,
        errors: state.errors.filter(
          (error) => error !== 'fetchingAnalyticsOrdersError'
        ),
        analyticsOrders: {
          rows: action.rows || [],
          totalCount: action.totalCount || 0,
          isFetching: false,
        },
      };

    case FETCH_ANALYTICS_ORDERS_FAILURE:
      return {
        ...state,
        analyticsOrders: {
          ...state.analyticsOrders,
          isFetching: false,
        },
        errors: [...state.errors, action.error],
      };

    case FETCH_ANALYTICS_SUMMARY:
      return {
        ...state,
        analyticsSummary: {
          ...state.analyticsSummary,
          isFetching: true,
        },
      };

    case FETCH_ANALYTICS_SUMMARY_SUCCESS:
      return {
        ...state,
        analyticsSummary: {
          data: action.data || {},
          isFetching: false,
        },
      };

    case FETCH_ANALYTICS_SUMMARY_FAILURE:
      return {
        ...state,
        analyticsSummary: {
          ...state.analyticsSummary,
          isFetching: false,
        },
        errors: [...state.errors, action.error],
      };

    case FETCH_ANALYTICS_PRODUCTS:
      return {
        ...state,
        analyticsProducts: {
          ...state.analyticsProducts,
          isFetching: true,
        },
      };

    case FETCH_ANALYTICS_PRODUCTS_SUCCESS:
      return {
        ...state,
        analyticsProducts: {
          items: action.items || [],
          isFetching: false,
        },
      };

    case FETCH_ANALYTICS_PRODUCTS_FAILURE:
      return {
        ...state,
        analyticsProducts: {
          ...state.analyticsProducts,
          isFetching: false,
        },
        errors: [...state.errors, action.error],
      };

    case RESET_REFERAL_ERRORS:
      return {
        ...state,
        errors: [],
      };

    default:
      return state;
  }
}
